<template>
  <div>
    <div class="grey-subhead-bg text-uppercase">
      <h1>Enter your Information</h1>
    </div>
    <div class="container">
      <br>
      <div class="errors" v-if="errors.length > 0">
        <div class="alert alert-danger">
          <ul>
            <li v-for="(error, index) in errors" :key="index">{{error}}</li>
          </ul>
        </div>
      </div>
      <h3>User Details</h3>
      <br>
      <div class="row">
        <div class="col-sm-4">
          <label for="">Username</label>
          <input
            v-model.trim="userFields.username"
            type="username"
            class="form-control client-form-control input-lg"
            placeholder="Username">
        </div>
        <div class="col-sm-4">
          <label for="">Password</label>
          <input
            v-model.trim="userFields.password"
            type="password"
            class="form-control client-form-control input-lg"
            placeholder="Password">
        </div>
        <div class="col-sm-4">
          <label for="">Email</label>
          <input
            v-model.trim="userFields.email"
            type="email"
            class="form-control client-form-control input-lg"
            placeholder="Email">
        </div>
      </div>
      <div class="row">
        <div class="col-sm-5">
          <label for="">First Name</label>
          <input
            v-model.trim="userFields.firstName"
            type="text"
            class="form-control client-form-control input-lg"
            placeholder="First Name">
        </div>
        <div class="col-sm-5">
          <label for="">Last Name</label>
          <input
            v-model.trim="userFields.lastName"
            type="text"
            class="form-control client-form-control input-lg"
            placeholder="Last Name">
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <label for="">Address</label>
          <input
            v-model.trim="userFields.address"
            type="text"
            class="form-control client-form-control input-lg"
            placeholder="Address">
        </div>
        <div class="col-sm-3">
          <label for="">City</label>
          <input
            v-model.trim="userFields.city"
            type="text"
            class="form-control client-form-control input-lg"
            placeholder="City">
        </div>
        <div class="col-sm-3">
          <label for="">State</label>
          <select
            v-model="userFields.state"
            class="form-control client-form-control input-lg">
            <option value="" disabled selected>States</option>
            <option
              v-for="(state, index) in states" :key="index"
              :value="state">
              {{ state }}
            </option>
          </select>
        </div>
        <div class="col-sm-2">
          <label for="">Zipcode</label>
          <input
            v-model.trim="userFields.zip"
            type="text"
            class="form-control client-form-control input-lg"
            placeholder="Zip">
        </div>
      </div>
      <div class="registration-form">
        <public-form
          :form="form"
          :completedForm="completedForm"></public-form>
      </div>
      <br>
      <br>
      <div class="col-sm-6 col-sm-offset-3">
        <a
          @click.prevent="submit"
          href=""
          class="btn client-btn-primary btn-lg btn-block text-uppercase"
          type="button">
          register now
        </a>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import PublicForm from '../../components/admin/registrationForm/PublicForm'

export default {
  name: 'ClientRegister',
  components: {
    'public-form': PublicForm
  },
  mounted () {
    this.getLoyaltyProgramBySlug(this.slug)
      .then(result => {
        if (!result.data.program) {
          this.$router.push({ name: 'ClientProgramNotFound' })
        }
      })
  },
  data () {
    return {
      userFields: {
        isAdmin: false,
        state: ''
      },
      errors: [],
      slug: this.$route.params.slug,
      completedForm: {},
      fieldMap: {
        address: 'Address',
        city: 'City',
        state: 'State',
        zip: 'Zip',
        email: 'Email',
        firstName: 'First Name',
        lastName: 'Last Name',
        username: 'Username',
        password: 'Password'
      },
      states: [
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'District of Columbia',
        'Florida',
        'Georgia',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming'
      ]
    }
  },
  computed: {
    ...mapGetters('loyaltyProgram', [ 'program', 'programId', 'usersRequireApproval' ]),
    ...mapState('loyaltyProgram', {
      form: state => state.program.registrationForm.formItems,
      approved: state => state.program.usersRequireApproval
    }),
    requiredUncommonFields () {
      return this.program.registrationForm.formItems.filter(item => item.required)
    },
    invalidFields () {
      const errorMessages = {
        'username-contains-spaces': 'Username cannot contain spaces'
      }
      const errorsMap = {
        'username-contains-spaces': this.userFields.username ? this.userFields.username.includes(' ') : false
      }
      return Object.keys(errorsMap).reduce((errorList, key) => {
        if (errorsMap[key]) errorList.push(errorMessages[key])
        return errorList
      }, [])
    }
  },
  methods: {
    ...mapActions('loyaltyProgram', [ 'getLoyaltyProgramBySlug' ]),
    ...mapActions('auth', [
      'register'
    ]),
    missingFields () {
      const missingCommonFields = Object.keys(this.fieldMap)
        .filter(key => !this.userFields[key])
        .map(key => this.fieldMap[key])

      const missingUncommonFields = this.requiredUncommonFields
        .filter(field => !this.completedForm[field.uid])
        .map(field => field.name)

      return [...missingCommonFields, ...missingUncommonFields]
    },
    submit () {
      if (this.invalidFields.length > 0) {
        const formattedErr = this.invalidFields.map(text => `    ${text}`).sort().join('\n')
        alert(`Please fix the following errors: \n${formattedErr}`)
        return
      }
      const fields = this.missingFields()
      if (fields.length > 0) {
        const formattedErr = fields.map(text => `    ${text}`).sort().join('\n')
        alert(`The following fields must be filled: \n${formattedErr}`)
        return
      }
      this.$bus.emit('global-load', { load: true, message: 'Registering user', env: 'admin' })
      this.register({
        user: this.userFields,
        loyaltyProgramId: this.programId,
        form: this.completedForm,
        approved: !this.usersRequireApproval,
        companyName: this.program.company ? this.program.company.name || '' : '',
        slug: this.program.slug
      })
        .then(response => {
          this.$bus.emit('global-load', { load: false })
          this.$router.push({
            name: 'ClientLogin'
          })
        })
        .catch(e => {
          this.$bus.emit('global-load', { load: false })
          const data = e.response.data
          console.log(e)
          if (data.msg === 'Failed to create user') {
            const respErr = data.err.error
            if (respErr.errors) {
              const msgs = Object.keys(respErr.errors).reduce((msgsArr, key) => {
                msgsArr.push(respErr.errors[key].message.replace('Path ', '').replace(key, this.fieldMap[key]))
                return msgsArr
              }, [])
              this.errors = msgs
            } else if (respErr.code === 11000) {
              const msg = `An account with the username "${respErr.errmsg.split('\"')[1]}" already exists`
              this.errors = [msg]
            }
          } else {
          // console.log(e.response)
            this.errors = [data.msg || e]
          }
        })
    }
  }
}
</script>
